import { render, staticRenderFns } from "./LoginSpecialForms.vue?vue&type=template&id=6b57b366&scoped=true&"
import script from "./LoginSpecialForms.vue?vue&type=script&lang=js&"
export * from "./LoginSpecialForms.vue?vue&type=script&lang=js&"
import style0 from "./LoginSpecialForms.vue?vue&type=style&index=0&id=6b57b366&lang=scss&scoped=true&"
import style1 from "./LoginSpecialForms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57b366",
  null
  
)

export default component.exports